Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetCurrentThemeId = void 0;
const getters_1 = require("./getters");
const admin_core_1 = require("@wheelroom/admin-core");
const react_1 = require("react");
exports.useGetCurrentThemeId = () => {
    const { adminCoreState } = react_1.useContext(admin_core_1.AdminCoreContext);
    const themeSwitcherStore = getters_1.getThemeSwitcherStore(adminCoreState);
    return themeSwitcherStore === null || themeSwitcherStore === void 0 ? void 0 : themeSwitcherStore.state.activeThemeId;
};
//# sourceMappingURL=use-get-current-theme-id.js.map